module.exports = __webpack_public_path__ + "img/montessori-1050x770.752dfa88.jpg";